module.exports = __webpack_public_path__ + "img/Hunter-troll-f-60.ec672e9b.gif";